import "./resources/solid-primereact.css";
import "./resources/globals.css";
import "./resources/stylesheets/layout.scss";
import "./resources/solid-responsive.css";
